export default __webpack_public_path__ + "static/media/CERT2-2.e7ab1e8e.png";